import { CalculationOverridesInput } from './calculation-overrides-input';
import { DimensionOverridesInput } from './dimension-overrides-input';
import { GeneralInput } from './general-input';
import { RecordIdInput } from './record-id-input';

export class InputGroup {
    constructor() {
        this.others = new GeneralInput();
        this.recordId = new RecordIdInput();
        this.calculationOverrides = new CalculationOverridesInput();
    }

    calculationType: number | string;
    recordId: RecordIdInput;
    dimensionOverrides: DimensionOverridesInput;
    calculationOverrides: CalculationOverridesInput;
    others: GeneralInput;
    pipeSizeType?: number;
    minimumPipeSizeId?: string;
    maximumPipeSizeId?: string;
    pipeSpecVersionId?: string;
    minimumNominalPipeSize?: number;
    maximumNominalPipeSize?: number;
    minimumPipeSize?: string;
    maximumPipeSize?: string;
    nominal?: number;
}
